import React from 'react';
import { StyledDialog } from './delivery-intro-dialog.style';

const DeliveryIntroDialog = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
    return (
        <StyledDialog isOpen={isOpen} onClose={onClose}>
            <h2>How delivery on Gumtree works</h2>
            <p>Buying and selling on Gumtree has never been easier!</p>
            <p>
                Our delivery service takes the hassle out of arranging meet-ups, couriers, or
                collections so you can trade with confidence from the comfort of your home.
            </p>
            <p>
                For sellers, the delivery cost is paid by the buyer and added automatically at
                checkout, ensuring the option is entirely cost-free for the seller.
            </p>
            <p>
                For buyers, Buyer Protection covers items that don't arrive, arrive damaged, or are
                significantly not as described.
            </p>
            <p>
                All payments are processed securely through Gumtree's trusted payment provider, with
                funds held safely until delivery is confirmed, providing a smoother and more secure
                exchange.
            </p>
            <p>
                Collection is always available if you prefer to meet in person. But for a smarter
                way to trade, Gumtree Delivery is quick to set up, easy to use, and protected every
                step of the way.
            </p>
        </StyledDialog>
    );
};

export default DeliveryIntroDialog;
